import { render, staticRenderFns } from "./assetCatalogue.vue?vue&type=template&id=2a656f7f&scoped=true"
import script from "./assetCatalogue.vue?vue&type=script&lang=js"
export * from "./assetCatalogue.vue?vue&type=script&lang=js"
import style0 from "./assetCatalogue.vue?vue&type=style&index=0&id=2a656f7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a656f7f",
  null
  
)

export default component.exports